import React, { useMemo } from 'react'
// import "./resultHeader.scss"
import { useSelector } from 'react-redux'
import { SelectTitliLastWinCard } from '../../../redux/titli-slice/gameInfoTitliSlice';
import moment from 'moment'

function ResultHistory() {
    let lastWinCards = useSelector(SelectTitliLastWinCard)

    const parseCard = (card) => {
      const [name, num, time] = card.split("|");
      return { name, num, time };
    };

    const animalImages = {
      "Ball": 'images/football111.gif',
      "Kite": 'images/kitework123.gif',
      "Cow": 'images/cat1212.gif',
      "Gariyo": 'images/horse1.gif',
      "Amrela": 'images/umbrela11.gif',
      "WatterDoll": 'images/bullet121.gif',
      "Butterfly": 'images/butterfly2121.gif',
      "Rose": 'images/rose132.gif',
      "Sun": 'images/tiger11.gif',
      "Lamp": 'images/dipak1231.gif',
      "Egle": 'images/kabutar123.gif',
      "Rebit": 'images/rabit132.gif'
    };

    const animalList = Object.keys(animalImages);

    return (
        <>
            <table width="100%">
                <tbody>
                    <tr>
                        <td>
                            <table width="100%" style={{ overflow: 'auto' }}>
                                <tbody>
                                    <tr>
                                        {lastWinCards.slice(-6).map((card, index) => {
                                            const { name,num, time } = parseCard(card);
                                            return (
                                                <td key={index} width="16.66%">
                                                    <div>
                                                        <center>
                                                            <div
                                                                className="block"
                                                                style={{
                                                                    border: 'red solid 6px',
                                                                    borderRadius: '25px',
                                                                    width: '95%',
                                                                    height: '135px',
                                                                    backgroundSize: 'cover',
                                                                    textAlign: 'center',
                                                                    boxShadow: '0 0 15px #a0522d',
                                                                    padding: '10px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <center>
                                                                    <img
                                                                        src={animalImages[name]}
                                                                        style={{
                                                                            width: '90px',
                                                                            height: '90px',
                                                                            marginBottom: '-2px',
                                                                        }}
                                                                        alt={name}
                                                                    />
                                                                </center>
                                                            </div>
                                                        </center>
                                                        <center>
                                                            <span
                                                                className="ll1 kab2"
                                                                style={{
                                                                    background: 'red',
                                                                    padding: '3px 10px',
                                                                    color: '#fff',
                                                                    fontSize: '22px',
                                                                    width: '100%',
                                                                    borderRadius: '10px',
                                                                    fontWeight: '600',
                                                                    display: 'inline-block',
                                                                }}
                                                            >
                                                                {time}  {num>0?'| '+num+'x' : ''}
                                                            </span>
                                                        </center>
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>

                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ResultHistory